import { render, staticRenderFns } from "./DrawingItem.vue?vue&type=template&id=5c805670&scoped=true"
import script from "./DrawingItem.vue?vue&type=script&lang=js"
export * from "./DrawingItem.vue?vue&type=script&lang=js"
import style0 from "./DrawingItem.vue?vue&type=style&index=0&id=5c805670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c805670",
  null
  
)

export default component.exports